import axios from "axios";

import { BASE_URL } from "./../../../constants";

export const REGISTER_URL = "api/auth/register";
export const ME_URL = `${process.env.REACT_APP_API_URL}/auth/me`;

// public
export const LOGIN_URL = `${BASE_URL}/public/login`;
export const REQUEST_PASSWORD_URL = `${BASE_URL}/public/forgotPassword`;
export const REQUEST_RESET_PASSWORD_URL = `${BASE_URL}/public/resetPassword`;
export const CHANGE_PROFILE_URL = `${BASE_URL}/private/updateProfile`;

export function login(email, password) {
  return axios.post(LOGIN_URL, { email, password });
}

export function updateProfile(profile) {
  return axios.put(CHANGE_PROFILE_URL, profile);
}

export function register(email, fullname, username, password) {
  return axios.post(REGISTER_URL, { email, fullname, username, password });
}

export function requestPassword(email) {
  return axios.post(REQUEST_PASSWORD_URL, { email });
}

export function resetPassword(values) {
  return axios.post(REQUEST_RESET_PASSWORD_URL, values);
}

export function getUserByToken() {
  // Authorization head should be fulfilled in interceptor.
  return axios.get({});
}
